export default "__VITE_ASSET__QMYsv6Mx__"